import Groups from './Groups';
import DialogOnCanvas from '../pages/canvas-pages/DialogOnCanvas';

const GroupsDialog = ({
  closeDialog,
  transitionDuration,
}: {
  closeDialog: () => void;
  transitionDuration?: number;
}) => {
  return (
    <DialogOnCanvas
      onClose={closeDialog}
      open={true}
      transitionDuration={transitionDuration}
      sx={{
        '.MuiPaper-root': {
          padding: '24px',
        },
      }}
    >
      <Groups onClose={closeDialog} isDialogLayout={true} />
    </DialogOnCanvas>
  );
};

export default GroupsDialog;
